// 从组件里迁移至此，作为公共方法，依赖window.pageData，复用的时候务必注意
import { reportError } from 'common/src/services/errorLogger';
export const confirmUserRole = () => {
    const pageData = window.pageData.data || window.pageData;
    if (!pageData) {
        reportError({
            error: 'pageData is undefined in confirmUserRole',
            componentName: 'userRole',
            additionalInfo: { desc: 'pageData未定义' },
        });
        return {};
    }
    const userInfo = pageData.teacher_info ||
        pageData.teacherInfo || pageData.user_info || {
            enterpriseInfo: {
                enterpriseId: '',
                role_type: -1,
            },
            is_department_manager: '0',
        };
    const enterpriseInfo = userInfo.enterpriseInfo || userInfo.enterprise_info;
    const roleType = enterpriseInfo ? Number(enterpriseInfo.role_type) : -1;

    return {
        isEnterMember: !!enterpriseInfo && !!enterpriseInfo.enterpriseId,
        isDepartment: userInfo && !!Number(userInfo.is_department_manager),
        isCAdmin: roleType === 9, // C 端管理员
        isSubAdmin: roleType === 5, // 系统子管理员
        isAdmin: roleType === 4, // 系统管理员
        isManage: roleType === 3, // 学习负责人
        isTeacher: roleType === 2, // 讲师
        isLearner: roleType === 1, // 学员
    };
};
